import React, { useEffect, useState } from 'react';
import styles from './Leaderboard.module.css';
import { collection, query, where, orderBy, limit, getDocs, Timestamp } from 'firebase/firestore';
import { storage, firestore, auth }  from "../../firebase/firebase.js";
import { useTranslation } from 'react-i18next';
import { HiTrophy, HiUsers, HiArrowTrendingUp, HiFilter } from 'react-icons/hi2';
import avatar from './../../assets/default-avatar.svg';
import CompactNavbar from './../CompactNavbar/CompactNavbar';
import { useAuth } from "../../utils/AuthContext/authcontext";
import ContactSidebar from './../ContactSidebar/ContactSidebar';

export default function Leaderboard() {
  const [leaders, setLeaders] = useState([]);
  const [timeframe, setTimeframe] = useState('all');
  const [debateStyle, setDebateStyle] = useState('');
  const [personalRank, setPersonalRank] = useState(null);
  const [loading, setLoading] = useState(true);
  const userId = auth.currentUser?.uid;
  const { t } = useTranslation();
  const [isContactOpen, setContactOpen] = useState(false);
  const {user, logout} = useAuth();
  
  const mlogout = () => {
  }


  useEffect(() => {
    const fetchLeaders = async () => {
      setLoading(true);
      let q = collection(firestore, 'users');

      // Timeframe filtering
      if (timeframe !== 'all') {
        const now = Timestamp.now();
        const days = timeframe === 'weekly' ? 7 : 30;
        const cutoff = Timestamp.fromMillis(now.toMillis() - days * 24 * 60 * 60 * 1000);
        q = query(q, where('lastActivity', '>=', cutoff));
      }

      if (debateStyle) {
        q = query(q, where('debateStyle', '==', debateStyle));
      }

      q = query(q, orderBy('reputation', 'desc'), limit(50));
      const snapshot = await getDocs(q);
      const users = snapshot.docs.map((doc, i) => ({ id: doc.id, rank: i + 1, ...doc.data() }));
      setLeaders(users);

      const myPos = users.find(u => u.id === userId);
      setPersonalRank(myPos?.rank ?? null);
      setLoading(false);
    };

    fetchLeaders();
  }, [timeframe, debateStyle, userId]);

  const top3 = leaders.slice(0, 3);
  const rest = leaders.slice(3);

  return (
    <>
	<div className={styles.header}>
		<CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
	</div>
    <div className={styles.container}>
      <h1 className={styles.title}><HiTrophy /> {t('leaderboard.title')}</h1>

      <div className={styles.filters}>
        <TimeframeFilter value={timeframe} onChange={setTimeframe} />
        <DebateStyleFilter value={debateStyle} onChange={setDebateStyle} />
      </div>

      {personalRank && <div className={styles.personal}>{t('leaderboard.youare')} #{personalRank}</div>}

      <div className={(top3.length <= 0 || top3.length > 0) && rest.length <= 0 ? styles.mainGridEmpty : styles.mainGrid}>
        <div className={styles.topPodium}>
          {top3.map(user => <PodiumCard key={user.id} user={user} />)}
        </div>

        {rest.length > 0 ? <div className={styles.fullBoard}>
          <h3 className={styles.subheading}><HiUsers /> {t('leaderboard.top50')}</h3>
          <div className={styles.list}>
            {rest.map(user => <LeaderboardCard key={user.id} user={user} />)}
          </div>
        </div> : <div className={top3.length > 0 ? styles.emptyhidepage : styles.emptypage}>{t('leaderboard.nodata')}</div>}
      </div>

      {loading && <div className={styles.loading}>{t('leaderboard.loading')}</div>}
    </div>
	<ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
	</>
  );
}

function PodiumCard({ user }) {
  const colors = ['#ffd700', '#c0c0c0', '#cd7f32'];
  const color = colors[user.rank - 1] || '#fff';

  return (
    <div className={styles.podiumCard} style={{ borderColor: color }}>
      <div className={styles.rank} style={{ color }}>{user.rank}</div>
      <img src={user.profilePicture || avatar} className={styles.avatar} alt="avatar" />
      <div className={styles.username}>{user.username}</div>
      <div className={styles.stats}>{user.wins} wins (#{user.reputation})</div>
    </div>
  );
}

function LeaderboardCard({ user }) {
  return (
    <div className={styles.listItem}>
      <div className={styles.rankNumber}>#{user.rank}</div>
      <img src={user.profilePicture || avatar} className={styles.avatarSmall} alt="avatar" />
      <div className={styles.username}>{user.username}</div>
      <div className={styles.stats}>{user.wins} wins (#{user.reputation})</div>
    </div>
  );
}

function TimeframeFilter({ value, onChange }) {
  const { t } = useTranslation();
  return (
    <div className={styles.filterBlock}>
      <label>{t('ui.timeframe')}</label>
      <select className={styles.threadSelect} value={value} onChange={e => onChange(e.target.value)}>
        <option value="all">{t('ui.allTime')}</option>
        <option value="monthly">{t('ui.monthly')}</option>
        <option value="weekly">{t('ui.weekly')}</option>
      </select>
    </div>
  );
}

function DebateStyleFilter({ value, onChange }) {
  const { t } = useTranslation();
  return (
    <div className={styles.filterBlock}>
      <label>{t('ui.debateStyle')}</label>
      <select className={styles.threadSelect} value={value} onChange={e => onChange(e.target.value)}>
        <option value="">All</option>
        <option value="Parliamentary">{t('ui.parliamentary')}</option>
        <option value="Lincoln-Douglas">{t('ui.lincolnDouglas')}</option>
        <option value="Oxford">{t('ui.oxford')}</option>
      </select>
    </div>
  );
}
